@if ({ view: view$ | async, flows: flows$ | async }; as source) {
  <div class='grid-wrapper'
    >
    @if (!this.ready) {
      <div class="loading">
        <div class="k-i-loading"></div>
      </div>
    }
    <!--
    Grid toolbar — icon-only buttons (28px) with tooltip and corner badges
    for premium (💎) and experimental (🧪) actions. Layout groups separated
    by vertical dividers. Selection-scoped buttons disable when nothing is
    selected. Right-click context menu still available as a backup entry.
    -->
    <div class="flex flex-wrap items-center gap-1 px-2 py-1.5">
      @if (this.fieldIsAdmin && !this.token_flow_a) {
        <button
          type="button" class="tb-btn"
          (click)="loginPowerAdmin()"
          title="Grant Admin Permission">
          <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true"></i>
        </button>
      }
      <button type="button" class="tb-btn"
        [class.tb-btn-active]="this.fieldSelectableMulti"
        (click)="this.fieldSelectableMulti = !this.fieldSelectableMulti"
        title="Toggle multi-select">
        <i class="ms-Icon ms-Icon--CheckboxComposite" aria-hidden="true"></i>
      </button>
      <button type="button" class="tb-btn" [disabled]="!selection.length"
        (click)="runAction('Enable')" title="Enable">
        <i class="ms-Icon ms-Icon--PowerButton" aria-hidden="true"></i>
      </button>
      <button type="button" class="tb-btn" [disabled]="!selection.length"
        (click)="runAction('Disable')" title="Disable">
        <i class="ms-Icon ms-Icon--Blocked2" aria-hidden="true"></i>
      </button>
      <button type="button" class="tb-btn" [disabled]="!selection.length"
        (click)="runAction('Duplicate')" title="Duplicate">
        <i class="ms-Icon ms-Icon--Copy" aria-hidden="true"></i>
      </button>
      <input type="search" placeholder="Search"
        class="inline-flex items-center rounded-lg shadow border-0 px-3 h-8 text-xs text-slate-600 bg-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
        [value]="search$ | async"
        (input)="search$.next($any($event.target).value)" />
        <button type="button" class="tb-btn" [disabled]="!selection.length"
          (click)="runAction('Delete')" title="Delete">
          <i class="ms-Icon ms-Icon--Delete" aria-hidden="true"></i>
        </button>
        <button type="button" class="tb-btn" [disabled]="!selection.length"
          (click)="runAction('Cancel All Runs')" title="Cancel all runs">
          <i class="ms-Icon ms-Icon--Cancel" aria-hidden="true"></i>
        </button>
        <div class="mx-1 h-5 w-px bg-slate-200" aria-hidden="true"></div>
        <button type="button" class="tb-btn"
          (click)="runAction('Export Excel')" title="Export Excel (subscription feature)">
          <i class="ms-Icon ms-Icon--ExcelDocument" aria-hidden="true"></i>
          <span class="tb-badge tb-badge-pro">PRO</span>
        </button>
        <button type="button" class="tb-btn" [disabled]="!selection.length"
          (click)="runAction('Edit JSON')" title="Edit JSON (subscription feature)">
          <i class="ms-Icon ms-Icon--CodeEdit" aria-hidden="true"></i>
          <span class="tb-badge tb-badge-pro">PRO</span>
        </button>
        <button type="button" class="tb-btn" [disabled]="!selection.length"
          (click)="runAction('Snapshots')" title="Snapshots (subscription feature)">
          <i class="ms-Icon ms-Icon--History" aria-hidden="true"></i>
          <span class="tb-badge tb-badge-pro">PRO</span>
        </button>
        <button type="button" class="tb-btn" [disabled]="!selection.length"
          (click)="runAction('Flow Diagram')" title="Flow Diagram (subscription feature)">
          <i class="ms-Icon ms-Icon--VisioDiagram" aria-hidden="true"></i>
          <span class="tb-badge tb-badge-pro">PRO</span>
        </button>
        <div class="mx-1 h-5 w-px bg-slate-200" aria-hidden="true"></div>
        <button type="button" class="tb-btn" [disabled]="!selection.length"
          (click)="runAction('Grant Admin as Flow Owner')" title="Grant Admin as Flow Owner (subscription feature)">
          <i class="ms-Icon ms-Icon--AddFriend" aria-hidden="true"></i>
          <span class="tb-badge tb-badge-pro">PRO</span>
        </button>
        <button type="button" class="tb-btn" [disabled]="!selection.length"
          (click)="runAction('Restore Soft Deleted Flow as Admin')" title="Restore soft-deleted flow (subscription feature)">
          <i class="ms-Icon ms-Icon--Undo" aria-hidden="true"></i>
          <span class="tb-badge tb-badge-pro">PRO</span>
        </button>
        @if (this.licenseHasTeams) {
          <div class="mx-1 h-5 w-px bg-slate-200" aria-hidden="true"></div>
          <button type="button" class="tb-btn" [disabled]="!selection.length"
            (click)="doMonitor()" title="Monitor flow (TEAMS license)">
            <i class="ms-Icon ms-Icon--RedEye" aria-hidden="true"></i>
            <span class="tb-badge tb-badge-team">TEAMS</span>
          </button>
        }
        <div class="mx-1 h-5 w-px bg-slate-200" aria-hidden="true"></div>
        <button type="button" class="tb-btn" [disabled]="!selection.length"
          (click)="runAction('Tag')" title="Tag (experimental)">
          <i class="ms-Icon ms-Icon--Tag" aria-hidden="true"></i>
          <i class="ms-Icon ms-Icon--TestBeakerSolid tb-badge-exp" aria-hidden="true"></i>
        </button>
        <button type="button" class="tb-btn" [disabled]="!selection.length"
          (click)="runAction('Owners')" title="Owners (experimental)">
          <i class="ms-Icon ms-Icon--People" aria-hidden="true"></i>
          <i class="ms-Icon ms-Icon--TestBeakerSolid tb-badge-exp" aria-hidden="true"></i>
        </button>
        @if (this.fieldIsAdmin) {
          <span class="ml-auto text-xs text-slate-400">Admin Flows is a <span class="pro-box"></span> subscription feature</span>
        }
      </div>
      <kendo-grid class="flows-grid"
        [class.has-multi-select]="this.fieldSelectable && this.fieldSelectableMulti"
        [data]="view$ | async"
        [sortable]="true"
        filterable="menu"
        [scrollable]="'virtual'"
        [rowHeight]="32"
        [resizable]="true"
        (dataStateChange)="dataStateChange($event)"
        [filter]="(state$ | async)?.filter"
        [sort]="(state$ | async)?.sort"
        [skip]="(state$ | async)?.skip"
        [pageSize]="(state$ | async)?.take ?? 100"
        [pageable]="false"
        [selectable]="this.fieldSelectable"
        [kendoGridSelectBy]="'flowName'"
        [(selectedKeys)]="selection"
        (cellClick)="openRunsFromGridCell($event)"
        [size]="'small'"
        [style.maxHeight]="this.gridHeight"
        [style.height]="this.gridHeight"
        #grid>
        <!-- <kendo-grid-column field="flowName" title="Flow Name" width="75" >
      </kendo-grid-column> -->
      <kendo-grid-checkbox-column
        [hidden]="!this.fieldSelectable || !this.fieldSelectableMulti"
        [width]="22"
        [style]="{'max-width':'22px', 'min-width':'22px', 'padding':'4px 0 4px 8px'}"
        [headerStyle]="{'max-width':'22px', 'min-width':'22px', 'padding':'4px 0 4px 8px'}"
      class="cell"></kendo-grid-checkbox-column>
      <kendo-grid-column field="shareOwners" title="Owner" [hidden]="!isColVisible('shareOwners')" [width]="30" [minResizableWidth]="30" [style]="{'min-width': '25px'}" class="cell">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
          <div>
            <multicheck-filter
              [isPrimitive]="false"
              [field]="column.field"
              [filterService]="filterService"
              [currentFilter]="filter"
              [data]="allOwners | async"
              [textField]="'text'"
              [valueField]="'value'"
            ></multicheck-filter>
          </div>
        </ng-template>
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <!-- <span [title]="dataItem.shareOwners | json">x</span> -->
          @if (dataItem.sharingType.includes('Coauthor')) {
            <span class='ms-Icon ms-Icon--People'
              [title]="'Shared Flow' + ((resolveOwners$(dataItem) | async) ? ' — owner: ' + (resolveOwners$(dataItem) | async) : '')"
            [ngStyle]="{'color': dataItem.userType == 'Owner' ? 'green': 'black' }"></span>
          }
          @if (dataItem.sharingType.includes('DelegatedAuth')) {
            <span class='ms-Icon ms-Icon--PeopleExternalShare'
              [title]="'Resource Owner' + ((resolveOwners$(dataItem) | async) ? ' — owner: ' + (resolveOwners$(dataItem) | async) : '')"
            [ngStyle]="{'color': dataItem.userType == 'Owner' ? 'dodgerblue': 'black' }"></span>
          }
          <!-- CDS + managed: combined icon. CDS as gray background, lock badged bottom-left. -->
          @if (dataItem.isManaged && (dataItem.sharingType.includes('CommonDataService') || dataItem.solution)) {
            <span class="cds-managed-stack"
              [title]="'Solution Aware (managed — locked from edits)' + ((resolveOwners$(dataItem) | async) ? ' — owner: ' + (resolveOwners$(dataItem) | async) : '')">
              <i class="ms-Icon ms-Icon--CommonDataServiceCDS cds-managed-bg"></i>
              <i class="ms-Icon ms-Icon--LockSolid cds-managed-lock"></i>
            </span>
          }
          <!-- Only CDS, not managed -->
          @if ((dataItem.sharingType.includes('CommonDataService') || dataItem.solution) && !dataItem.isManaged) {
            <i class="ms-Icon ms-Icon--CommonDataServiceCDS"
              [title]="'Solution Aware' + ((resolveOwners$(dataItem) | async) ? ' — owner: ' + (resolveOwners$(dataItem) | async) : '')"
            [ngStyle]="{'color': '#742873' }"></i>
          }
          <!-- Only managed, not CDS -->
          @if (dataItem.isManaged && !(dataItem.sharingType.includes('CommonDataService') || dataItem.solution)) {
            <i class="ms-Icon ms-Icon--LockSolid" title="Managed solution flow — locked from edits in this environment"
            [ngStyle]="{'color': '#8a8886' }"></i>
          }
          <!-- Single owner — Fluent v2 person (regular). -->
          @if (hasSingleOwner(dataItem)) {
            <svg class="fluent-icon"
              viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <title>{{ resolveOwners$(dataItem) | async }}</title>
              <path d="M11.5 8c.83 0 1.5.67 1.5 1.5v.5c0 1.97-1.86 4-5 4-3.14 0-5-2.03-5-4v-.5C3 8.67 3.67 8 4.5 8h7Zm0 1h-7a.5.5 0 0 0-.5.5v.5c0 1.44 1.43 3 4 3 2.57 0 4-1.56 4-3v-.5a.5.5 0 0 0-.5-.5ZM8 1.5A2.75 2.75 0 1 1 8 7a2.75 2.75 0 0 1 0-5.5Zm0 1A1.75 1.75 0 1 0 8 6a1.75 1.75 0 0 0 0-3.5Z"/>
            </svg>
          }
          <!-- Multi-owner — Fluent v2 peopleTeam (regular). -->
          @if (dataItem.owners?.length > 1) {
            <svg class="fluent-icon"
              viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <title>{{ resolveOwners$(dataItem) | async }}</title>
              <path d="M6 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm3 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-9-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM3 4.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM4.27 7A2 2 0 0 0 4 8H2v2.5a1.5 1.5 0 0 0 2.1 1.38c.07.33.19.64.34.94A2.5 2.5 0 0 1 1 10.5V8a1 1 0 0 1 1-1h2.27Zm7.3 5.82A2.5 2.5 0 0 0 15 10.5V8a1 1 0 0 0-1-1h-2.27A2 2 0 0 1 12 8h2v2.5a1.5 1.5 0 0 1-2.1 1.38c-.07.33-.19.64-.34.94ZM6 7a1 1 0 0 0-1 1v3a3 3 0 0 0 6 0V8a1 1 0 0 0-1-1H6Zm0 1h4v3a2 2 0 0 1-4 0V8Z"/>
            </svg>
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="displayName" title="Display Name" [hidden]="!isColVisible('displayName')" [width]="160" class="cell">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <!-- <link class="k-icon k-i-plus" (click)="doGetRuns(dataItem)" style="cursor: pointer;" title="Open Runs" *ngIf="dataItem.runsCount" /> -->
          <div style="display: flex; justify-content: space-between;">
            <div style="align-self:flex-start;min-width: 0; overflow: hidden; text-overflow: ellipsis;">
              <a [routerLink]="['/flows', dataItem.environment, dataItem.flowName, 'view']"
                [title]="dataItem.displayName">
                <span style="margin-right: 5px;" [style.text-decoration]="dataItem.flowState=='Deleted'? 'line-through': ''">{{dataItem.displayName}}</span>
              </a>
            </div>
            <div style="align-self:flex-end;min-width: 50px; text-align: right;">
              <!-- v2 maker portal — append ?v3=false to the classic URL. -->
              @if (isFlowLinkVisible('v2')) {
                <a
                  href="{{this.apiRoot}}/manage/environments/{{dataItem.environment}}/flows/{{dataItem.sharingType=='Coauthor'?'shared/':''}}{{dataItem.flowName}}?v3=false"
                  title="Maker Portal v2" target="_blank"
                  class="flow-edit-link hover-only">
                  <i class="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
                  <span class="flow-edit-link__badge">2</span>
                </a>
              }
              <!-- v3 maker portal — same URL with ?v3=true. -->
              @if (isFlowLinkVisible('v3')) {
                <a
                  href="{{this.apiRoot}}/manage/environments/{{dataItem.environment}}/flows/{{dataItem.sharingType=='Coauthor'?'shared/':''}}{{dataItem.flowName}}?v3=true"
                  title="Maker Portal v3" target="_blank"
                  class="flow-edit-link hover-only">
                  <i class="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
                  <span class="flow-edit-link__badge">3</span>
                </a>
              }
              <!-- v4 Copilot Studio portal uses workflowEntityId for solution flows. -->
              @if (isFlowLinkVisible('v4') && (dataItem.workflowEntityId || dataItem.solution)) {
                <a
                  href="https://copilotstudio.preview.microsoft.com/environments/{{dataItem.environment}}/flows/{{dataItem.workflowEntityId || dataItem.solution}}/"
                  title="Copilot Studio v4" target="_blank"
                  class="flow-edit-link hover-only">
                  <i class="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
                  <span class="flow-edit-link__badge">4</span>
                </a>
              }
              <!-- Favourite (heart) — temporarily hidden, will return later.
              <i class="ms-Icon ms-Icon--Heart hover-only" style='font-weight:bold; margin-right: 5px; cursor: pointer;'
                (click)="dataItem.favourite = true;"
              *ngIf="!dataItem.favourite" aria-hidden="true" title="Favourite"></i>
              <i class="ms-Icon ms-Icon--HeartFill" style='font-weight:bold; margin-right: 5px; cursor: pointer; color: red;'
                (click)="dataItem.favourite = false;"
              *ngIf="dataItem.favourite" aria-hidden="true" title="Favourite"></i>
              -->
              <!-- <i class="ms-Icon ms-Icon--Play hover-only" style='font-weight:bold; margin-right: 5px; cursor: pointer;' aria-hidden="true" (click)="doRunNow(dataItem)" title="Run Now" *ngIf="dataItem.trigger == 'Request' && dataItem.triggerKind == 'Button'"></i>                -->
              <i class="ms-Icon ms-Icon--More" style='font-weight:bold; cursor: pointer;' aria-hidden="true" (click)="reContextMenu($event)" title="More Commands"></i>
            </div>
          </div>
        </ng-template>
        <ng-template kendoGridFooterTemplate let-column="column">
          @if (source.view.total != source.flows.length) {
            <span title='Filtered Flows'>{{source.view.total}}&nbsp;/&nbsp;</span>
          }
          <span title='Total Flows'>{{source.flows.length}}&nbsp;</span>
          @if (!(this.flowsLoaded$ | async)) {
            <span><span class='ms-Icon ms-Icon--Clock' title='loading runs'></span>...{{this.flowsLoading$ | async}}</span>
          }
          <!-- Refresh moved to app header (app.component.html). -->
          <span style="margin-left: 6px;">{{ flowManagementService.serviceStatus$ | async }}</span>
          @if (this.hasFilter$ | async) {
            <span title="click to clear filter" style="text-decoration: underline; cursor: pointer;" (click)="this.clearFilter()"><span class='ms-Icon ms-Icon--ClearFilter'></span> Results are filtered</span>
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="monitor" [hidden]="!this.fieldRuns || !this.licenseHasTeams || !isColVisible('monitor')" title="Monitor" [width]="30" [minResizableWidth]="30" type="text"
        [filterable]="true" [style]="{'max-width': '30px'}" class="cell">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="cell">
            @if (dataItem.monitored) {
              <i class="ms-Icon ms-Icon--RedEye" style='cursor: pointer; color:green;' aria-hidden="true" title="Flow Monitored" (click)="doMonitor(dataItem)"></i>
            }
            @if (!dataItem.monitored) {
              <i class="ms-Icon ms-Icon--RedEye hover-only" style='cursor: pointer;' aria-hidden="true" title="Monitor this flow" (click)="doMonitor(dataItem)"></i>
            }
            <!-- <kendo-switch [(ngModel)]="dataItem.monitored" [size]="'small'"></kendo-switch> -->
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="runsSort" [hidden]="!this.fieldRuns || !isColVisible('runsColorBar')" title="Runs" [width]="40" [minResizableWidth]="25" type="number" filter="numeric" [filterable]="false" class="cell" [style]="{'min-width': '40px', 'text-overflow': 'initial', 'overflow': 'hidden', 'cursor': 'pointer'}">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.runsCount > 0) {
            <div class="sparkline-cell">
              <kendo-sparkline
                type="column"
                renderAs="canvas"
                (click)="doGetRuns(dataItem)"
                >
                <kendo-chart-area background="transparent" [margin]="0">
                </kendo-chart-area>
                <kendo-chart-tooltip>
                  <ng-template kendoChartSeriesTooltipTemplate let-value="value">
                    <!-- start: {{ value | json }} <br> -->
                    duration: {{ value }}ms
                  </ng-template>
                </kendo-chart-tooltip>
                <kendo-chart-series>
                  <kendo-chart-series-item type="column" [data]="dataItem?.runsSparkline">
                  </kendo-chart-series-item>
                </kendo-chart-series>
              </kendo-sparkline>
            </div>
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="tags" title="Tags" [hidden]="!isColVisible('tags')" [width]="80" [minResizableWidth]="80" class="cell" [style]="{'min-width': '50px'}">
        <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
          <div>
            <multicheck-filter
              [isPrimitive]="true"
              [field]="column.field"
              [filterService]="filterService"
              [currentFilter]="filter"
              [data]="flowTags"
            ></multicheck-filter>
            <!-- <kendo-multiselect style="width:220px" [data]="flowTags" [valuePrimitive]="true" [value]="multiFilters(filter)"
            [autoClose]="false"
            [checkboxes]="true"
            (valueChange)="multiChange($event, filterService, 'tags', 'contains')" (click)="$event.stopPropagation()">
          </kendo-multiselect> -->
        </div>
      </ng-template>
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (this.bgColor(dataItem)) {
          <div style="width:20px;height:20px;display:inline-block;vertical-align:middle; margin-right:3px;"
          [style.background-color]='this.bgColor(dataItem)'>&nbsp;</div>
        }
        @for (tag of dataItem.tags; track tag) {
          <span style='margin-right:5px;'><a class='flow-tag cell-filter' href='javascript:void(0)'
          (click)='this.filterByTag(tag)'>{{tag}}</a></span>
        }
        <span class='hover-only' style="margin-right: 5px; cursor: pointer;" (click)="doTags(dataItem)" title="Change Tags"><i class="ms-Icon ms-Icon--CirclePlus" style='font-weight:bold;' aria-hidden="true"></i></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="trigger" title="Trigger" [hidden]="!isColVisible('trigger')" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}" class="cell">
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
        <div style="height:200px;">
          <multicheck-filter
            [isPrimitive]="true"
            [field]="column.field"
            [filterService]="filterService"
            [currentFilter]="filter"
            [data]="flowTriggers"
          ></multicheck-filter>
          <!-- <kendo-multiselect style="width:220px" [data]="flowTriggers" [valuePrimitive]="true" [value]="multiFilters(filter)"
          [autoClose]="false"
          (valueChange)="multiChange($event, filterService, 'trigger', 'eq')">
        </kendo-multiselect> -->
      </div>
    </ng-template>
    <ng-template kendoGridHeaderTemplate let-column>
      <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class='cell cell-filter' title='{{dataItem.triggerTooltip || dataItem.trigger}}' (click)='this.filterByTrigger(dataItem.trigger)'><img
        [src]='this.getTriggerIcon(dataItem)'
        onerror="this.onerror=null; this.src='/assets/customconnectoricon.png';"
        style='width:20px; height:20px; vertical-align:middle;' />
      {{dataItem.trigger}}</div>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="triggerKind" title="Kind" [hidden]="!isColVisible('triggerKind')" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}" class="cell">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <div style="height:200px;">
        <multicheck-filter
          [isPrimitive]="true"
          [field]="column.field"
          [filterService]="filterService"
          [currentFilter]="filter"
          [data]="flowTriggerKinds"
        ></multicheck-filter>
        <!-- <kendo-multiselect style="width:220px" [data]="flowTriggerKinds" [valuePrimitive]="true" [value]="multiFilters(filter)"
        [autoClose]="false"
        (valueChange)="multiChange($event, filterService, 'triggerKind', 'eq')">
      </kendo-multiselect> -->
    </div>
  </ng-template>
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <div class='cell cell-filter' title='{{dataItem.triggerTooltip || dataItem.triggerKind}}' (click)='this.filterByTriggerKind(dataItem.triggerKind)'>{{dataItem.triggerKind}}</div>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="actionsCount" [hidden]="!this.fieldRuns || !isColVisible('actionsCount')" title="# Actions" [width]="25" [minResizableWidth]="25" type="number" filter="numeric"
  [filterable]="false" [style]="{'min-width': '25px'}" class="cell">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title='{{dataItem.actionsTooltip}}'>{{dataItem.actionsCount}}</span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="flowState" title="On/Off" [hidden]="!isColVisible('flowState')" [width]="30" [minResizableWidth]="30" [style]="{'min-width': '30px'}" class="cell">
  <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
    <div style="height:200px">
      <multicheck-filter
        [isPrimitive]="true"
        [field]="column.field"
        [filterService]="filterService"
        [currentFilter]="filter"
        [data]="flowStates"
      ></multicheck-filter>
      <!-- <kendo-multiselect style="width:220px" [data]="flowStates" [valuePrimitive]="true" [value]="multiFilters(filter)"
      [autoClose]="false"
      (valueChange)="multiChange($event, filterService, 'flowState', 'eq')">
    </kendo-multiselect> -->
  </div>
</ng-template>
<ng-template kendoGridHeaderTemplate let-column>
  <i class="ms-Icon ms-Icon--PowerButton" style='font-weight:bold;' aria-hidden="true" title="{{column.title}}"></i>
</ng-template>
<ng-template kendoGridCellTemplate let-dataItem>
  @switch (dataItem.flowState) {
    @case ('Started') {
      <span class='cell cell-filter' style='color:green;'
        (click)='this.filterByFlowState(dataItem.flowState)' title='Started'>
        <i class="ms-Icon ms-Icon--PowerButton" style='font-weight:bold;' aria-hidden="true"></i>
      </span>
    }
    @case ('Stopped') {
      <span class='cell cell-filter' style='color:gray'
        (click)='this.filterByFlowState(dataItem.flowState)' title='Stopped'>
        <i class="ms-Icon ms-Icon--Blocked2" style='font-weight:bold;' aria-hidden="true"></i>
      </span>
    }
    @case ('Deleted') {
      <span class='cell cell-filter' style='color:red'
        (click)='this.filterByFlowState(dataItem.flowState)' title='Deleted'>
        <i class="ms-Icon ms-Icon--Blocked2" style='font-weight:bold;' aria-hidden="true"></i>
      </span>
    }
    @case ('Suspended') {
      <span class='cell cell-filter' style='color:red'
        (click)='this.filterByFlowState(dataItem.flowState)' [title]="('Suspended: ')+(dataItem.flowSuspensionReason)">
        <i class="ms-Icon ms-Icon--ShieldAlert" style='font-weight:bold;' aria-hidden="true"></i>
      </span>
    }
    @default {
      <span>{{dataItem.flowState}}</span>
    }
  }
</ng-template>
</kendo-grid-column>
<kendo-grid-column field="modified" title="Last Modified" [hidden]="!isColVisible('modified')" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}"
  filter="date" class="cell" [style]="{'min-width': '65px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
    <!-- <i class="ms-Icon ms-Icon--DateTime" style='font-weight:normal;' aria-hidden="true" title="{{column.title}}"></i> -->
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title="{{dataItem.modified|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.modified|date:'y-MM-dd HH:mm'}}</span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="runsSort" title="Runs" [hidden]="!isColVisible('runsSort')" [width]="35" [minResizableWidth]="35" type="number" filter="numeric"
  [filterable]="false" class="cell" [style]="{'min-width': '25px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    @if (dataItem.runsEstimate > 20) {
      <i class="ms-Icon ms-Icon--Error" style='font-weight:bold; color:orange; margin-right: 5px; cursor: pointer;' aria-hidden="true"
        (click)="doRunHint(dataItem)"
      ></i>
    }
    <span title="Estimated run rate per month {{dataItem.runsEstimate|number:'0.0-0'}}" style="cursor: pointer;" (click)="doGetRuns(dataItem)">{{dataItem.runsCount}}@if (dataItem.more) {
      <span
      title='There are more pages of runs.'>+</span>
    }</span>
    <!-- <span *ngIf="dataItem.loading" title='loading'>...</span> -->
  </ng-template>
  <ng-template kendoGridFooterTemplate let-column="column">
    <span title='Total Runs Loaded'>{{this.runsCountTotal$ | async}}</span>
    <!-- <span *ngIf="this.loading">...</span> -->
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="runsFailCount" [hidden]="!this.fieldRuns || !isColVisible('runsFailCount')" title="Fails" [width]="25" [minResizableWidth]="25" type="number" filter="numeric"
  [filterable]="false" [style]="{'min-width': '25px'}" class="cell">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    @if (dataItem.runsFailCount > 10) {
      <i class="ms-Icon ms-Icon--Error" style='font-weight:bold; color:red; margin-right: 5px; cursor: pointer;' aria-hidden="true"
      ></i>
    }
    <span title="{{ dataItem.runsCount? ((dataItem.runsFailCount/dataItem.runsCount) | percent) : ''}}" style="cursor: pointer;" (click)="doGetRuns(dataItem, false, 'Failed')">{{dataItem.runsFailCount}}</span>
    <!-- <span *ngIf="dataItem.loading" title='loading'>...</span> -->
  </ng-template>
  <ng-template kendoGridFooterTemplate let-column="column">
    <span title='Total Fails Loaded'>{{this.runsFailCountTotal$ | async}}</span>
    <!-- <span *ngIf="this.loading">...</span> -->
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="lastRun" [hidden]="!this.fieldRuns || !isColVisible('lastRun')" title="Last Ran" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}"
  filter="date" class="cell" [style]="{'min-width': '65px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
    <!-- <i class="ms-Icon ms-Icon--EventDateMissed12" style='font-weight:normal;' aria-hidden="true" title="{{column.title}}"></i> -->
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title="{{dataItem.lastRun|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.lastRun|date:'y-MM-dd HH:mm'}}</span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column class="clip cell" [width]="16" [minResizableWidth]="16" [headerStyle]="{ 'min-width': '16px', 'text-overflow': 'clip' }">
  <ng-template kendoGridHeaderTemplate let-column>
    <kendo-grid-column-chooser ></kendo-grid-column-chooser>
  </ng-template>
  <ng-template kendoGridFooterTemplate let-column="column">
    <span class='ms-Icon ms-Icon--Cancel' title='cancel loading' (click)='this.cancel()'></span>
  </ng-template>
</kendo-grid-column>
<!-- <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="this.hasRuns">
<app-flow-runs [flow]="dataItem" [runs]="dataItem.runsLoaded" [nested]="true"></app-flow-runs>
</ng-template> -->
<kendo-grid-excel fileName="flows.xlsx" [fetchData]="allData">
  <kendo-excelexport-column field="displayName" title="Display Name">
    <ng-template kendoExcelExportFooterTemplate>
      {{(this.flows$ | async).length}}
    </ng-template>
  </kendo-excelexport-column>
  <kendo-excelexport-column field="tagsText" title="Tags"></kendo-excelexport-column>
  <kendo-excelexport-column field="trigger" title="Trigger"></kendo-excelexport-column>
  <kendo-excelexport-column field="triggerKind" title="Kind"></kendo-excelexport-column>
  <kendo-excelexport-column field="actionsCount" title="Actions"></kendo-excelexport-column>
  <kendo-excelexport-column field="flowState" title="On/Off"></kendo-excelexport-column>
  <kendo-excelexport-column field="sharingType" title="Owner"></kendo-excelexport-column>
  <kendo-excelexport-column field="modified" title="Last Modified"></kendo-excelexport-column>
  <kendo-excelexport-column field="lastRun" title="Last Ran"></kendo-excelexport-column>
  <kendo-excelexport-column field="runsSort" title="Runs">
    <ng-template kendoExcelExportFooterTemplate>
      {{this.runsCountTotal$ | async}}
    </ng-template>
  </kendo-excelexport-column>
  <kendo-excelexport-column field="runsFailCount" title="Fails">
    <ng-template kendoExcelExportFooterTemplate>
      {{this.runsFailCountTotal$ | async}}
    </ng-template>
  </kendo-excelexport-column>
  <kendo-excelexport-column field="flowName" title="Flow Name"></kendo-excelexport-column>
  <kendo-excelexport-column field="actionsTooltip" title="Flow Actions"></kendo-excelexport-column>
</kendo-grid-excel>
<ng-template kendoGridNoRecordsTemplate>
  @switch(true) {
    @case (!this.token_flow && !this.fieldIsAdmin) {
      <p>No records available.  <button kendoButton (click)="loginPowerConsent()">Click to grant permission to Power Automate API</button></p>
    }
    @case (!this.token_flow_a && this.fieldIsAdmin) {
      <p>No records available.  <button kendoButton (click)="loginPowerAdmin()">Click to grant permission to Power Platform API</button></p>
    }
    @case ((this.loading$ | async)) {
      <span class="inline-flex items-center gap-2 text-slate-500">
        <span class="k-icon k-i-loading"></span>
        <span>{{ (this.flowManagementService.serviceStatus$ | async) || 'Loading flows…' }}</span>
      </span>
    }
    @case (!(this.flowsLoaded$ | async)) {
      <span class="inline-flex items-center gap-2 text-slate-500">
        <span class="k-icon k-i-loading" title="loading runs"></span>
        <span>Loading runs… {{this.flowsLoading$ | async}}</span>
      </span>
    }
    @case ((this.flowsLoaded$ | async) && (this.hasFilter$ | async)) {
      <span title="click to clear filter" style="text-decoration: underline; cursor: pointer;" (click)="this.clearFilter()"><span class='k-icon k-i-filter-clear'></span> Try remove filters.</span>
    }
    @default {
      <p>There is no data to display.</p>
    }
  }
</ng-template>
<ng-template
  kendoPagerTemplate
  let-totalPages="totalPages"
  let-currentPage="currentPage"
  >
  <kendo-pager-prev-buttons size="small"></kendo-pager-prev-buttons>
  <kendo-pager-numeric-buttons size="small" [buttonCount]="buttonCount"></kendo-pager-numeric-buttons>
  <kendo-pager-next-buttons size="small"></kendo-pager-next-buttons>
  <kendo-pager-input size="small"></kendo-pager-input>
  <kendo-pager-info size="small"></kendo-pager-info>
  <kendo-pager-page-sizes size="small" [pageSizes]="[50,100,150,500,1000]"></kendo-pager-page-sizes>
</ng-template>
</kendo-grid>
<grid-context-menu [for]="grid" [menuItems]="['Enable', 'Disable', 'Edit JSON']" [admin]="this.fieldIsAdmin" [filter]="onFilter.bind(this)" (select)="onSelect($event)"></grid-context-menu>
<!-- {{this.state | json }} -->
<ng-template #multiConfirm>
  <p>This action will affect {{ items.length }} items:</p>
  <ul>
    @for (item of items; track item) {
      <li>{{ item }}</li>
    }
  </ul>
</ng-template>
<ng-template #deleteConfirm>
  <div class="p-1">
    <p class="text-sm text-slate-700 mb-2">
      @if (items.length === 1) {
        Permanently delete this flow:
      }
      @if (items.length > 1) {
        Permanently delete {{ items.length }} flows:
      }
    </p>
    <ul class="text-sm text-slate-900 mb-3 max-h-40 overflow-auto pl-5 list-disc">
      @for (item of items; track item) {
        <li>{{ item }}</li>
      }
    </ul>
    <p class="text-sm text-slate-700 mb-1">
      Type <code class="px-1.5 py-0.5 rounded bg-slate-100 text-slate-900 text-xs">{{ deleteConfirmExpected }}</code> to confirm:
    </p>
    <input type="text"
      class="w-full rounded-lg border border-slate-300 px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-300 focus:border-red-400"
      [value]="deleteConfirmInput"
      (input)="deleteConfirmInput = $any($event.target).value"
      autofocus />
    </div>
  </ng-template>
</div>
}
